import { defineComponent as _defineComponent } from 'vue'
import { useDeleteIroMutation } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteIro',
  props: {
    iroId: null
  },
  setup(__props: any) {


const { mutate: deleteIro, loading } = useDeleteIroMutation()

return { __sfc: true,deleteIro, loading }
}

})